import TaskAlt from '@mui/icons-material/TaskAlt';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { AlertStatus } from 'lib/alert/models';
import React from 'react';
import { MANTY_GREEN, MANTY_RED } from 'styles/theme';

const AlertBadge = ({ status }: { status: AlertStatus }) => {
    if (status === AlertStatus.TRIGGERED)
        return (
            <ReportGmailerrorredIcon
                sx={{ color: MANTY_RED, fontSize: '40px' }}
            />
        );

    return <TaskAlt sx={{ color: MANTY_GREEN, fontSize: '40px' }} />;
};

export default AlertBadge;
